<template>
    <ejs-grid 
      ref="normGrid"
      :dataSource="parentGrid" 
      :childGrid="childGrid"
      :allowPaging="true" 
      :allowSorting='true' 
      :allowFiltering='true' 
      :pageSettings='pageSettings'
      :toolbar="toolbar"
      :filterSettings="{ type: 'Menu' }"
      @toolbarClick="onToolbarClick"
    >
      <e-columns>
        <e-column field="prefijo" headerText="Prefijo" />
        <e-column field="articulo" headerText="Artículo" />
        <e-column field="tipo" headerText="Tipo" />
        <e-column field="numero" headerText="Número" />
        <e-column field="anio" headerText="Año" />
        <e-column field="denominacion" headerText="Expedida por" :customAttributes="{class: 'textComplete'}" width="20%" />
        <e-column field="razonSocial" headerText="Tenant" v-if="$validPermission('NORM')"/>
        <e-column :template="actionsTemplate" headerText="Acciones"/>
      </e-columns>
    </ejs-grid>
</template>

<script>
import { AxiosAdaptor } from '@src/adapters/syncfusion-axios-adaptor';

import Actions from './partials/Actions.vue';
import Compliance from './partials/Compliance.vue';

import { DataManager } from '@syncfusion/ej2-data';
import { 
  GridComponent, 
  ColumnDirective, 
  ColumnsDirective, 
  Page, 
  Sort, 
  Filter, 
  Toolbar, 
  DetailRow
} from "@syncfusion/ej2-vue-grids";

export default {
  name: "norm-search",
  props: {
    showEditProp: {
      type: Boolean,
      default: false,
    },
    showTenantColumnProp: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'Actions': Actions,
    'Compliance': Compliance,
  },
  data() {
    return {
      pageSettings: { pageSize: 10 },
      parentGrid: new DataManager({
        url: '/norms/search',
        adaptor: new AxiosAdaptor(),
      }),
      childGrid: {
        height: '300px',
        dataSource: new DataManager({
          url: '/norms/compliances',
          adaptor: new AxiosAdaptor(),
        }),
        queryString: 'id',
        columns: [
          { 
            field: 'titulo', 
            headerText: 'Cumplimiento',
            customAttributes: {class: 'textComplete'},
            template: () => {
              return { template: Compliance };
            }
          },
          { field: 'periodicidad', headerText: 'Periodicidad' },
          { field: 'relevancia', headerText: 'Relevancia' },
        ]
      },
      toolbar: [{
        text: 'Limpiar',
        tooltipText: '',
        prefixIcon: 'e-clear',
        id: 'customClearFilter',
        align: 'Right',
        cssClass: 'btn'
      }],
      actionsTemplate() {
        return {
          template: {
            extends: Actions,
          }
        };
      },
    }
  },
  provide: {
    grid: [Page,Sort,Filter,Toolbar,DetailRow]
  },
  methods: {
    onToolbarClick(args) {
      if (args.item.id === 'customClearFilter') {
        const grid = this.$refs.normGrid.ej2Instances;
        grid.clearFiltering();
      }
    },
    refreshGrid() {
      const grid = this.$refs.normGrid.ej2Instances;
      grid.refresh();
    }
  },
  created() {
    this.$eventHub.$on('onResetSwitchTenantsStructuring', () => {
      this.refreshGrid();
    });

    this.$eventHub.$on('refreshNormSearchGrid', () => {
      this.refreshGrid();
    });
  }
};
</script>